import React, { useEffect } from 'react'
import { useWorkStateFields } from '../../store/hooks';
import './WorkDetails.css'
import { albumSelection, past_face_searches, userFolders } from '../../context/workConstants.js';
import { get_platform_bg_color } from '../../script/util.js';
import { getSelectedData } from './work_utils.js';

const WorkDetailStory = ({ handleCollections, indiFaceData }) => {
    const {
        data, currentDimensions, albumTitle, storyRef, contentLoading, pillMargin,
        faceSearchOn, 
        pastFaceSearches,
        pastFaceSearchesOn,
        croppedImages,
    } = useWorkStateFields(['data', 'currentDimensions', 'albumTitle', 'contentLoading', 'pillMargin', 'faceSearchOn', 'pastFaceSearches', 'pastFaceSearchesOn', 'croppedImages']);
    const queryParams = new URLSearchParams(window.location.search);
    const collection_id = queryParams.get("work_id")
    const tab = queryParams.get("tab")

    const splitTitle = (title) => {
        if (title.length > 11) {
            const [firstWord, ...rest] = title.split(" ");
            const restOfString = rest.join(" ");
            return [firstWord, restOfString];
        } else {
            return [title];
        }
    }

    useEffect(() => {
        const targetStory = document.getElementsByClassName('openClass')[0];
        if (targetStory) {
            const parentElement = targetStory?.parentElement?.parentElement;
            if (parentElement) {
                const offsetLeft = targetStory.offsetLeft;
                parentElement.scrollTo({
                    left: offsetLeft-50,
                    behavior: "smooth",
                });
            }
        }
    }, [contentLoading]);

    return (
        <div id='storyNav' ref={storyRef} style={{display: (pastFaceSearchesOn ? pastFaceSearches : data?.data) && ((pastFaceSearchesOn ? pastFaceSearches : getSelectedData(data, tab))?.length>1) ? "flex" : 'none', overflow: "auto"}}>
            {data?.data && !(tab==past_face_searches) && (getSelectedData(data, tab))?.map((e, index)=>(
            <div onClick={()=>handleCollections(e.work_id)} key={index} className={currentDimensions < 1200 ? `storyDiv ${contentLoading && 'inactiveClass'}` : `pillStoryDiv ${contentLoading && 'inactiveClass'}`} style={{background: e.work_id == collection_id && currentDimensions > 1200 && get_platform_bg_color(), color: e.work_id == collection_id && currentDimensions > 1200 && 'white', boxShadow: e.work_id == collection_id && currentDimensions > 1200 && "0 -2px 10px rgba(0, 0, 0, 0.4)", display: faceSearchOn && 'none', margin: `15px ${pillMargin}px`}}>
                <img className={currentDimensions < 1200 ? `imgStory ${e.work_id == collection_id && 'openClass'}` : `pillImgStory ${e.work_id == collection_id && 'openClass'}`} style={{border: e.work_id == collection_id && currentDimensions <1200 && `3px solid ${get_platform_bg_color()}`}} src={e?.cover_image}/>
                <div style={{display:"flex", flexDirection:"column"}}>{splitTitle((tab==albumSelection || tab==userFolders) && e.work_id == collection_id && albumTitle ? albumTitle : e.title).map((e, index)=>{
                    return (
                        <span style={{whiteSpace:"nowrap"}} key={index}>{e.length>11 ? e.slice(0,8)+'...' : e}</span>
                    )
                })}
                </div>
            </div>
            ))}
            {pastFaceSearches && pastFaceSearchesOn && tab==past_face_searches && pastFaceSearches?.map((e, index)=>(
                <div onClick={()=>indiFaceData(e._id)} key={index} className={currentDimensions < 1200 ? `storyDiv ${contentLoading && 'inactiveClass'}` : `pillStoryDiv ${contentLoading && 'inactiveClass'}`} style={{background: e._id == collection_id && currentDimensions > 1200 && get_platform_bg_color(), color: e._id == collection_id && currentDimensions > 1200 && 'white', boxShadow: e._id == collection_id && currentDimensions > 1200 && "0 -2px 10px rgba(0, 0, 0, 0.4)", display: (faceSearchOn && !pastFaceSearchesOn) && 'none', margin: `15px ${pillMargin}px`, minWidth: 'fit-content', paddingRight: '3px'}}>
                    <img className={currentDimensions < 1200 ? `imgStory ${e._id == collection_id && 'openClass'}` : `pillImgStory ${e._id == collection_id && 'openClass'}`} style={{border: e._id == collection_id && currentDimensions <1200 && `3px solid ${get_platform_bg_color()}`, marginRight: '0'}} src={croppedImages[index]}/>
                </div>
            ))}
        </div>
    )
}

export default WorkDetailStory